import { render } from "./LabInformation.vue?vue&type=template&id=5f96bffe"
import script from "./LabInformation.vue?vue&type=script&lang=js"
export * from "./LabInformation.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/labs/LabInformation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f96bffe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f96bffe', __exports__)) {
    console.log('reload')
    api.reload('5f96bffe', __exports__)
  }
  
  module.hot.accept("./LabInformation.vue?vue&type=template&id=5f96bffe", () => {
    console.log('re-render')
    api.rerender('5f96bffe', render)
  })

}


export default __exports__